interface ApplePaySessionConstructor {
  canMakePayments(): boolean;
}

// Global Apple Pay constructor provided by the browser (only available in
// supporting environments).
declare const ApplePaySession: ApplePaySessionConstructor | undefined;

const showWarnAndReturn = () => {
  console.warn('Apple Pay is not available and was removed from payment methods list');
  return false;
};

export const checkCanMakePaymentsWithApplePay = (): boolean => {
  try {
    if (!ApplePaySession) {
      return showWarnAndReturn();
    }
    const canMakePayments = ApplePaySession.canMakePayments();
    return canMakePayments || showWarnAndReturn();
  } catch {
    return showWarnAndReturn();
  }
};
